import { render, staticRenderFns } from "./MiniDash.vue?vue&type=template&id=50006ed3&scoped=true"
import script from "./MiniDash.vue?vue&type=script&lang=js"
export * from "./MiniDash.vue?vue&type=script&lang=js"
import style0 from "./MiniDash.vue?vue&type=style&index=0&id=50006ed3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50006ed3",
  null
  
)

export default component.exports